/* eslint-disable padding-line-between-statements */
export const CURRENT_LADDER_TOTAL_AMOUNT = 15384615;
export const LAST_LADDER_INDEX = 6;
export const CRYPTO_TIMEOUT_HOURS = 12;
export const WIRE_TIMEOUT_HOURS = 100 * 365 * 24;

// from Login page
export const EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
